import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

const RING = "BONA FIDE \u2022 UNAFFECTED \u2022 GUNTUR \u2022 ANDHRA PRADESH \u2022 CIVIL \u2022 LEGAL \u2022 PROPERTY \u2022 ";

export const Seal = ({ size = "w-[78vw] max-w-[520px]" }) => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [14, -14]), { stiffness: 120, damping: 14 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-16, 16]), { stiffness: 120, damping: 14 });
  const gx = useTransform(mx, [-0.5, 0.5], ["20%", "80%"]);
  const gy = useTransform(my, [-0.5, 0.5], ["20%", "80%"]);

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };

  return (
    <div
      className={`relative aspect-square ${size} [perspective:1200px]`}
      onMouseMove={onMove}
      onMouseLeave={reset}
      data-testid="hero-seal"
    >
      <div className="absolute inset-[-14%] rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.28)_0%,rgba(212,175,55,0.06)_40%,transparent_68%)] blur-2xl" />
      <svg viewBox="0 0 200 200" className="absolute inset-[-9%] w-[118%] h-[118%] animate-[spin_60s_linear_infinite]" aria-hidden>
        <defs>
          <path id="ringpath" d="M100,100 m-92,0 a92,92 0 1,1 184,0 a92,92 0 1,1 -184,0" />
        </defs>
        <text fill="#C5A059" fontSize="6.4" letterSpacing="2.6" fontFamily="JetBrains Mono, monospace">
          <textPath href="#ringpath">{RING}</textPath>
        </text>
      </svg>
      <motion.div
        style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }}
        initial={{ scale: 0.82, opacity: 0, rotateZ: -12 }}
        animate={{ scale: 1, opacity: 1, rotateZ: 0 }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1], delay: 0.35 }}
        className="relative w-full h-full rounded-full shadow-[0_40px_120px_-20px_rgba(0,0,0,0.8),0_0_0_1px_rgba(197,160,89,0.35)]"
      >
        <img src="/logo.webp" alt="Ridhanya Associates seal" className="w-full h-full rounded-full object-cover select-none" draggable={false} />
        <motion.div
          className="absolute inset-0 rounded-full mix-blend-soft-light pointer-events-none"
          style={{ background: useTransform([gx, gy], ([x, y]) => `radial-gradient(circle at ${x} ${y}, rgba(255,240,200,0.75), transparent 45%)`) }}
        />
      </motion.div>
    </div>
  );
};
